module.exports = __webpack_public_path__ + "static/media/2020-UIL-Area-State-5-person-panel-Adjudication-Sheets.750cffa4.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/band/20-21/2020-UIL-Area-State-5-person-panel-Adjudication-Sheets.pdf
// module id = 196
// module chunks = 0